import axios from "axios"
import baseURL from "../configs/api"

export const put_FleetSettings = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}fleetSetting?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getFleetSettings = (tenantId: string) => {
    return getFetch("fleetSetting", tenantId)
}

export const getFleetSetting = (primaryKey: string, tenantId: string) => {
    return getFetch(`fleetSetting/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}